function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLglogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 563.84302,
    height: 497.73099,
    viewBox: "0 0 563.84301 497.73099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath26)",
    transform: "matrix(1.33333 0 0 -1.33333 -284.413 606.608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-212.124-253.309L-422.686 3.137s52.904 116.852 212.902 116.852C-49.78 119.989 0 0 0 0",
    style: {
      fill: "#d1d3d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(636.192 334.967)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-197.994-235.305L-394.532 2.916s49.381 108.547 198.721 108.547C-46.465 111.463 0 0 0 0",
    style: {
      fill: "#c80a4e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(622.115 332.664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-142.937-174.88L-284.791 2.167s32.485 80.672 143.478 80.672C-30.32 82.839 0 0 0 0",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(567.245 300.394)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 2.781 3.667L18.125-7.966 24.83.879l3.316-2.513-9.484-12.512Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(254.248 342.317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.381.866-2.771 1.037-4.177.51-.788-.307-1.507-.791-2.157-1.454-1.25-1.27-1.772-2.814-1.564-4.628.206-1.816 1.325-3.722 3.358-5.718 2.046-2.012 3.932-2.99 5.654-2.938 1.724.053 3.142.646 4.249 1.775 1.088 1.106 1.646 2.346 1.674 3.716.027 1.371-.426 2.669-1.358 3.896l-3.593-3.66-2.777 2.727L5.806.842l8.957-8.798-2.159-2.198-2.43 1.701c.168-1.411.164-2.53-.014-3.361-.285-1.422-1.056-2.773-2.316-4.055-2.057-2.093-4.508-3.058-7.358-2.893-2.904.118-5.695 1.489-8.366 4.112-2.701 2.651-4.173 5.486-4.416 8.495-.234 3.021.784 5.686 3.059 8.003 1.979 2.016 4.104 3.106 6.378 3.273 2.274.168 4.302-.444 6.082-1.839z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(281.41 362.74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 2.458-3.316-5.355-3.971L8.589-22.782l-3.75-2.782-11.488 15.497-5.355-3.97-2.458 3.314z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(301.028 387.956)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 9.123-10.256 2.377-2.947-1.213 3.507L5.871 3.289l4.281 2.399 8.854-10.406 2.414-2.929-1.16 3.464-4.05 13.267 4.114 2.303 6.013-23.473-3.868-2.167L13.43-3.602 10.532-.053l1.533-4.331 4.348-13.261-3.762-2.107L-4.305-2.41z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(305.754 391.005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4.204-1.869-9.511 21.4 4.206 1.867z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(341.572 383.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.547 1.65 13.899-12.317-5.563 15.339 4.041 1.466 7.984-22.014-4.34-1.574L6.342-4.89l5.681-15.659-4.039-1.466z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(334.96 405.951)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.399-.996.871-1.695 1.408-2.102.981-.739 2.378-.874 4.188-.409 1.078.277 1.925.625 2.54 1.045 1.167.8 1.587 1.838 1.257 3.116-.192.747-.657 1.242-1.393 1.489-.735.234-1.823.332-3.263.29L2.275 3.37c-2.427-.058-4.145.119-5.154.526-1.717.672-2.861 2.122-3.433 4.344-.52 2.028-.245 3.897.826 5.603C-4.414 15.55-2.509 16.755.23 17.46c2.286.586 4.399.454 6.343-.397 1.943-.847 3.259-2.468 3.95-4.855L6.23 11.103c-.433 1.342-1.257 2.163-2.474 2.462-.818.194-1.758.156-2.815-.119-1.184-.3-2.066-.793-2.646-1.464-.58-.673-.757-1.452-.531-2.334.207-.807.709-1.323 1.504-1.546.518-.152 1.552-.22 3.101-.203l4.002.03c1.762.015 3.133-.216 4.121-.694 1.553-.738 2.586-2.114 3.105-4.132.53-2.068.214-3.981-.954-5.738-1.165-1.758-3.131-2.993-5.899-3.703-2.818-.726-5.213-.622-7.18.307-1.967.929-3.252 2.574-3.857 4.927z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(362.754 398.264)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .845-6.203 5.35.73c.953.13 1.674.368 2.168.713.895.636 1.244 1.671 1.048 3.103C9.247-.447 8.667.319 7.674.646 7.12.828 6.367.858 5.41.738Zm-1.223 8.953.702-5.131 5.358.733c.956.129 1.705.425 2.251.891.545.466.75 1.19.617 2.166-.148 1.085-.641 1.747-1.476 1.988-.719.148-1.603.15-2.652.006Zm11.75 3.183c.811-.895 1.31-2.029 1.499-3.404.193-1.417.004-2.602-.563-3.556-.315-.536-.815-1.052-1.496-1.55 1.179-.277 2.12-.844 2.824-1.701.703-.854 1.145-1.947 1.326-3.279.19-1.376.029-2.655-.48-3.835a6.34 6.34 0 0 0-1.315-2.04c-.619-.662-1.396-1.163-2.327-1.503a14.596 14.596 0 0 0-3.066-.739l-9.927-1.353-3.164 23.201 10.655 1.454c2.686.322 4.696-.241 6.034-1.695",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(387.598 406.793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 5.655.307-3.284 9.034Zm-.486 14.547 5.234.284 9.09-22.96L8.822-8.4 7.104-3.681l-8.151-.443-1.24-4.879-4.849-.263z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(409.42 407.684)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.121-1.065.388-1.864.797-2.4.748-.973 2.057-1.476 3.924-1.512 1.111-.022 2.021.089 2.726.328 1.342.46 2.024 1.349 2.044 2.668.017.771-.3 1.372-.942 1.805-.649.424-1.668.808-3.067 1.152l-2.386.601C.738 3.235-.869 3.864-1.732 4.526c-1.476 1.107-2.192 2.806-2.149 5.101.039 2.097.803 3.822 2.292 5.18 1.487 1.357 3.644 2.009 6.474 1.957 2.361-.045 4.362-.738 6.007-2.074 1.645-1.336 2.482-3.249 2.507-5.734l-4.428.082c-.064 1.409-.637 2.419-1.729 3.032-.736.407-1.649.619-2.746.639-1.219.023-2.199-.211-2.937-.706-.741-.494-1.12-1.195-1.135-2.105-.016-.835.329-1.467 1.033-1.892.459-.284 1.44-.627 2.938-1.025L8.257 5.94c1.7-.456 2.966-1.044 3.79-1.769 1.295-1.123 1.925-2.728 1.887-4.809-.043-2.137-.86-3.896-2.455-5.277-1.588-1.38-3.815-2.045-6.674-1.992-2.91.054-5.188.792-6.836 2.214-1.647 1.422-2.447 3.347-2.4 5.778z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(426.975 406.611)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-11.454 1.121-.479-4.917L-1.46-4.821l-.397-4.043-10.472 1.026-.598-6.061 11.992-1.174-.406-4.143-16.5 1.617 2.283 23.305L.402 4.142z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(459.104 416.666)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-.973-5.087 5.314-1.016c.947-.181 1.755-.139 2.42.129.662.268 1.09.887 1.273 1.858.206 1.074-.047 1.859-.767 2.352-.633.369-1.467.655-2.508.854Zm-1.695-8.875-1.177-6.147 5.305-1.016c.943-.182 1.705-.187 2.279-.015 1.055.318 1.713 1.187 1.984 2.604.233 1.198-.076 2.113-.913 2.738-.466.35-1.172.617-2.116.811zM12.148-.73c.488-1.106.601-2.342.339-3.704-.266-1.405-.824-2.468-1.667-3.191-.467-.406-1.107-.737-1.915-.993 1.031-.639 1.742-1.477 2.135-2.512.398-1.034.467-2.211.217-3.533-.262-1.362-.821-2.523-1.68-3.48a6.39 6.39 0 0 0-1.894-1.513c-.805-.43-1.697-.658-2.686-.684-.99-.025-2.039.069-3.143.278l-9.843 1.883L-3.59 4.82 6.976 2.799c2.647-.55 4.375-1.724 5.172-3.529",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(466.667 415.512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 5.423-1.641-.007 9.613Zm4.501 13.84 5.02-1.518.721-24.683-4.81 1.456-.004 5.021L-2.39-3.52l-2.825-4.165-4.647 1.405z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(485.795 400.411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.242-1.779-7.445-17.757 10.236-4.293-1.612-3.836-14.478 6.071z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(504.945 409.516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 4.047-2.188-9.156-16.937 9.765-5.279-1.979-3.661-13.816 7.468z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(521.725 402.263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.581.464 4.974-.13 7.178-1.785 2.944-2.213 4.323-4.859 4.136-7.942-.109-1.728-.575-3.194-1.398-4.395L6.234-11.36c.433 1.078.638 1.979.619 2.71-.056 1.309-.728 2.451-2.027 3.427-1.328.994-2.8 1.206-4.417.635-1.619-.57-3.214-1.904-4.783-3.996-1.573-2.088-2.348-3.958-2.322-5.604.021-1.646.65-2.931 1.887-3.861 1.273-.953 2.576-1.231 3.92-.837.723.21 1.574.706 2.543 1.486l3.685-2.764c-1.854-1.805-3.91-2.856-6.172-3.155-2.269-.304-4.417.312-6.455 1.842-2.521 1.894-3.858 4.243-4.009 7.05-.149 2.816.912 5.73 3.176 8.743C-5.676-2.425-2.97-.531 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(543.682 386.486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.351-3.158L-9.854-17.17l8.073-7.612-2.855-3.028-11.425 10.767z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(560.639 376.442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.032-3.592-10.976-9.278c-1.232-1.038-2.01-1.933-2.343-2.686-.64-1.276-.343-2.641.885-4.093 1.217-1.445 2.511-1.96 3.878-1.543.795.203 1.81.824 3.037 1.862l10.98 9.276 3.038-3.594-10.998-9.29c-1.903-1.609-3.616-2.58-5.147-2.917-2.825-.597-5.482.576-7.97 3.52-2.486 2.942-3.202 5.763-2.148 8.452.587 1.456 1.832 2.985 3.735 4.592z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(574.073 363.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4.344-2.813 2.936-4.541C-.885-8.163-.297-8.715.359-9.011c.653-.294 1.392-.175 2.22.363.919.594 1.308 1.322 1.173 2.182-.175.712-.547 1.513-1.122 2.402zm-7.585-4.908-5.253-3.403 2.931-4.533c.524-.806 1.046-1.359 1.569-1.657.956-.543 2.04-.419 3.254.368 1.022.661 1.472 1.514 1.345 2.552-.073.578-.364 1.273-.876 2.088zM7.872-9.28c-.462-1.116-1.278-2.051-2.441-2.804-1.202-.776-2.356-1.11-3.461-1.003-.616.057-1.294.29-2.038.697.249-1.185.135-2.279-.338-3.279-.474-.999-1.279-1.865-2.407-2.597-1.164-.753-2.39-1.153-3.672-1.193a6.388 6.388 0 0 0-2.407.321c-.863.283-1.644.773-2.347 1.468a14.65 14.65 0 0 0-1.976 2.465l-5.443 8.41L1.003 5.928 6.844-3.1c1.434-2.293 1.777-4.354 1.028-6.18",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(587.275 340.377)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h10.652v-27.068h15.842v-9.025H0Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(393.25 363.12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.875-2.88-5.326-4.511-9.695-4.511-9.412 0-15.508 7.488-15.508 19.007 0 11.71 6.912 18.912 18.24 18.912 4.556 0 8.447-1.201 11.43-3.505 3.015-2.398 4.17-4.752 4.652-9.503H-2.064c-.293 2.785-2.357 4.558-5.141 4.558-4.272 0-6.814-3.98-6.814-10.605 0-6.721 2.64-10.753 7.009-10.753 3.502 0 5.469 1.921 6.285 6.242h-6.859v7.582H9.119V-3.598H0Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(447.33 330.625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s21.115-33.025-56.309-30.319c0 0-80.672 10.287-90.959-38.983 0 0-6.476-26.166 38.453-22.288 0 0-37.241 7.449-7.451 33.931 0 0 9.106 11.583 50.483 13.239h.004c-6.047-17.004-31.011-86.147-45.213-109.345l35.193 12.453 2.707 14.078 29.512 82.838h.808s55.225-6.497 62.805 21.657c0 0 3.789 16.785-20.033 22.739",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(366.316 342.625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 18.95 2.167 6.497-44.938L46.563 4.874 64.43 7.038l8.662-37.899 17.326 41.148 17.326 1.084-22.741-62.806-25.987-1.083L54.684-15.7 37.358-59.015l-25.989-6.497Z",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(324.627 278.195)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-19.491-57.392L0-54.145 19.492 0Z",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(448.613 292.815)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-18.408-54.143L0-51.977l9.747 32.486 18.408-28.155 16.242-1.083L61.723 2.166H42.231L34.652-30.32 16.243.541Z",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(483.265 293.897)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s21.116-33.026-56.309-30.319c0 0-80.672 10.286-90.959-38.983 0 0-6.477-26.167 38.452-22.288 0 0-37.241 7.448-7.449 33.931 0 0 9.105 11.583 50.482 13.239h.004c-6.046-17.004-31.012-86.148-45.213-109.346l35.192 12.453 2.707 14.078 29.512 82.839h.808s55.225-6.498 62.806 21.656c0 0 3.791 16.784-20.033 22.74",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(360.902 346.957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 18.949 2.166 6.498-44.938L46.563 4.873 64.43 7.039l8.662-37.9 17.325 41.149 17.326 1.082-22.739-62.806-25.988-1.084-4.332 36.818-17.327-43.313-25.988-6.499z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(319.213 282.527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-19.49-57.391L0-54.142 19.491 0Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(443.2 297.146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-18.408-54.143L0-51.978l9.744 32.486 18.41-28.155 16.242-1.082L61.723 2.164H42.231L34.65-30.321 16.242.541Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(477.852 298.23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-7.578-10.286s-33.568 4.873-33.568-7.581c0 0 .54-7.579 16.242-6.495 0 0 23.281-2.166 20.574-20.035 0 0 3.791-18.95-40.066-20.032 0 0-63.346-1.084-132.108-22.199 0 0-48.728-12.994-74.718-33.568l-48.727 7.58S-184.625-61.181-64.97-59.015c0 0 42.773 2.165 43.314 14.618 0 0 1.625 9.204-18.95 8.665 0 0-20.575-1.084-21.116 14.076 0 0-7.039 31.944 61.722 21.656",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(606.168 294.98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-7.581-10.286s-33.568 4.872-33.568-7.581c0 0 .541-7.58 16.242-6.497 0 0 23.281-2.166 20.574-20.033 0 0 3.79-18.95-40.065-20.032 0 0-63.346-1.084-132.108-22.199 0 0-48.728-12.994-74.719-33.568l-48.726 7.579s115.324 51.435 234.979 53.601c0 0 42.772 2.166 43.315 14.619 0 0 1.623 9.205-18.951 8.663 0 0-20.574-1.082-21.116 14.078 0 0-7.038 31.944 61.724 21.656",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(600.756 299.312)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLglogo);
export default __webpack_public_path__ + "static/media/lglogo.bce0d2ccdc0b4996ccb1a5c1dd807010.svg";
export { ForwardRef as ReactComponent };